import { defineComponent, watch, toRefs, onUpdated, onMounted, ref } from 'vue'

export default defineComponent({
    props: {
        //开放性标签id
        launchId: {
            type: String,
            default: 'launch-id'
        },
        //app的id
        username: {
            type: String,
            default: 'gh_xxxxxxxx'
        },
        //绑定数据，数据变化重新执行app高度函数
        path: {
            type: String,
            default: 'pages/home/index?user=123&action=abc'
        }
    },
    setup(props) {
        const { launchId, username, path } = toRefs(props)
        let content = ref('');
        //用户点击跳转按钮后出现错误
        const error = (errMsg: Event) => {
            console.log(errMsg);
        }
        const initApp = () => {
                                content.value = `
                                <div style="width: 40vw;
                                height: 10.667vw;
                                line-height: 10.667vw;
                                box-shadow: 0px 0.267vw 1.067vw 0px rgb(11 37 113 / 30%);
                                border-radius: 1.6vw;
                                font-size: 15px;
                                color: white;
                                background-image: linear-gradient(to right, #1890ff, #5c7efa);
                                ">
                                跳转到小程序
                                </div>
                               <wx-open-launch-weapp
                                   style="
                                   position: absolute;
                                   left: 0px;
                                   top: 0px;
                                   width: 100%;
                                   height: 100%;"
                                   id=${launchId.value}
                                   username=${username.value}
                                   path=${path.value}
                                >
                                <script type="text/wxtag-template">
                                    <div style="
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 100%;
                                    height: 100%;
                                    opacity: 0;"></div>
                                </script>
                              </wx-open-launch-weapp>`
        }
        onUpdated(() => {
            const documenCopy:any = document
            if (documenCopy && documenCopy.querySelector(`.jumpWxApp #${launchId.value}`)) {
                documenCopy.querySelector(`.jumpWxApp #${launchId.value}`).addEventListener("ready", function (e: any) {
                    console.log("ready-APP", e)
                })
                documenCopy.querySelector(`.jumpWxApp #${launchId.value}`).addEventListener("launch", function (e: any) {
                    console.log("launch-APP", e)
                })
                documenCopy.querySelector(`.jumpWxApp #${launchId.value}`).addEventListener("error", function (e: any) {
                    console.log('error-APP', e, e.detail)
                    error(e)
                });
            }
        })
        onMounted(() => {
            initApp()
        })
        watch(path, (newValue, oldValue) => {
            initApp()
        })
        watch(username, (newValue, oldValue) => {
            initApp()
        })
        return () => (
            <div class="jumpApp" style={{
                position: 'relative',
            }} id="jumpApp" v-html={content.value}></div>
        )
    }
})


